import { render } from "./DecorationDigitizationCard.vue?vue&type=template&id=1ce9d419&scoped=true"
import script from "./DecorationDigitizationCard.vue?vue&type=script&lang=js"
export * from "./DecorationDigitizationCard.vue?vue&type=script&lang=js"

import "./DecorationDigitizationCard.vue?vue&type=style&index=0&id=1ce9d419&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce9d419"]])

export default __exports__